import cn from 'classnames'
import React from 'react'
import { IconCell } from '../icon-cell'
import { Typography } from '../typography'
import { ItemElementProps } from './Menu.types'
import styles from './MenuItem.module.css'
import { MenuItemContentProps } from './MenuItem.types'

function Content({ children, glyph, rightSlot, supportingText }: MenuItemContentProps) {
  return (
    <>
      {glyph
        ? <IconCell glyph={glyph} size="sm" />
        : <IconCell glyph="QuestionMarkInCircle" size="sm" hidden />}
      <div className={styles.textCell}>
        <Typography variant="body-m-regular-tight">{children}</Typography>
        {supportingText && (
          <Typography variant="body-s-regular-tight" className={styles.supportingText}>
            {supportingText}
          </Typography>
        )}
      </div>
      {rightSlot && (
        <Typography variant="body-m-regular-tight" className={styles.rightSlot}>
          {rightSlot}
        </Typography>
      )}
    </>
  )
}

export function MenuItem({ ref, children, glyph, rightSlot, supportingText, className, ...rest }: ItemElementProps) {
  return (
    <button type="button" ref={ref} className={cn(styles.itemWrapper, className)} {...rest}>
      <Content glyph={glyph} rightSlot={rightSlot} supportingText={supportingText}>
        {children}
      </Content>
    </button>
  )
}

export function MenuLinkItem({ ref, children, glyph, rightSlot, supportingText, className, ...rest }: ItemElementProps<'a'>) {
  return (
    <a ref={ref} className={cn(styles.itemWrapper, className)} {...rest}>
      <Content glyph={glyph} rightSlot={rightSlot} supportingText={supportingText}>
        {children}
      </Content>
    </a>
  )
}
